import { Card, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { EdgesInputStyles } from "../../../../Constant";
import { EDGES_INPUT_STYLES } from "../../../../Data/FormControl/BaseInput";
import { EdgesInputCardBody } from "./EdgesInputCardBody";
import { EdgesInputCardFooter } from "./EdgesInputCardFooter";

const EdgesInputStyle = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={EdgesInputStyles} span={EDGES_INPUT_STYLES} />
        <Form className="theme-form dark-inputs" onSubmit={(e)=>e.preventDefault()}>
          <EdgesInputCardBody/>
          <EdgesInputCardFooter/>
        </Form>
      </Card>
    </Col>
  );
};

export default EdgesInputStyle;
